class NewsletterModal extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['modal', 'close', 'backdrop']
  }

  constructor () {
    super()

    if (!this.noLocalStorageSet) return

    this.onLoad = this.onLoad.bind(this)
    window.setTimeout(this.onLoad, parseInt(this.dataset.showModal))
  }

  setupListeners () {
    super.setupListeners()

    this.onCloseClick = this.onCloseClick.bind(this)
    this.onEscapePress = this.onEscapePress.bind(this)

    this.listeners.add(this.els.close.element, 'click', this.onCloseClick)
    this.listeners.add(this.els.backdrop.element, 'click', this.onCloseClick)
    this.listeners.add(document, 'keyup', this.onEscapePress)
  }

  onLoad () {
    this.els.modal.element.setAttribute('data-hidden', false)

    if (this.modalState) {
      document.body.classList.add('util-SiteOverflowed')
    }
  }

  onCloseClick () {
    this.els.modal.element.setAttribute('data-hidden', true)

    if (this.modalState) {
      document.body.classList.remove('util-SiteOverflowed')
    }

    this.onClose()
  }

  onEscapePress (event) {
    if (event.key === 'Escape') {
      this.els.modal.element.setAttribute('data-hidden', true)

      if (this.modalState) {
        document.body.classList.remove('util-SiteOverflowed')
      }

      this.onClose()
    }
  }

  onClose () {
    window.localStorage.setItem(this.localStorageName, 'true')
  }

  timeout () {}

  get modalState () {
    return this.els.modal.element.getAttribute('data-hidden')
  }

  get noLocalStorageSet () {
    return (
      window.localStorage.getItem(this.localStorageName) === undefined ||
      window.localStorage.getItem(this.localStorageName) === null
    )
  }

  get localStorageName () {
    return `Sunspel-newsletter`
  }
}

if (!customElements.get('newsletter-modal')) {
  customElements.define('newsletter-modal', NewsletterModal)
}
